<script setup lang="ts">
import SpotThePhishPage from "shared-ui/pages/SpotThePhishPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    headerTitleKey: "spot_the_phish_page.title",
  },
});
</script>

<template>
  <SpotThePhishPage />
</template>

<style scoped lang="css"></style>
